export enum StatusTagColorEnum {
  LIGHT_GREEN = 'light-green',
  LIGHT_RED = 'light-red',
  LIGHT_BLUE = 'light-blue',
  LIGHT_YELLOW = 'light-yellow',
}

export enum SummaryStatusEnum {
  DONE = 'DONE',
  PROCESSING = 'PROCESSING',
  CANCEL = 'CANCEL',
  TO_BE_STARTED = 'TO_BE_STARTED',
}
